import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyHotelSearch = loadable(() => import(/* webpackChunkName: "content/hotel/search" */ './HotelSearch'), 'HotelSearch');
